<template>
  <O3D>
    <!-- <SwatWalk></SwatWalk> -->
    <!-- <Church></Church> -->
    <O3D :sx="0.7" :sy="0.7" :sz="0.7" :px="100" :pz="-500" :py="-0.7" :ry="pi * 0.25">
      <FactoryPlace v-if="chroma" :envMap="chroma.out.envMap"></FactoryPlace>
    </O3D>

    <!-- <O3D :py="40" :pz="-100">
      <O3D layout="loklok">
        <WoozyLayer :pz="-5" :py="8"></WoozyLayer>
        <LokLokText></LokLokText>
      </O3D>
    </O3D> -->

    <O3D layout="overall" v-if="ready">

      <!--

        <O3D :px="0" :pz="80" :py="80">
          <PointLight :distance="0" :color="0xffffff" :helper="isDev && off" :intensity="0.6"></PointLight>
        </O3D>
        <O3D :px="0" :pz="-80" :py="80">
          <PointLight :distance="0" :color="0xffffff" :helper="isDev && off" :intensity="0.6"></PointLight>
        </O3D>
        <O3D :px="0" :pz="0" :py="80">
          <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && off" :intensity="0.4"></HemisphereLight>
        </O3D>
        <O3D :px="0" :pz="0" :py="80">
          <AmbinetLight :color="0xffffff" :helper="isDev && off" :intensity="0.1"></AmbinetLight>
        </O3D>

      -->

      <O3D :pz="-25">

        <O3D :sx="5" :sy="5" :sz="5" :pz="50">
          <O3D :px="0" :pz="10" :py="50">
            <PointLight :decay="2" :distance="0" :color="0xffffff" :helper="isDev && isOn" :intensity="0.4"></PointLight>
          </O3D>

          <O3D :px="0" :pz="-10" :py="18">
            <PointLight :decay="2" :distance="0" :color="0xffffff" :helper="isDev && isOn" :intensity="0.4"></PointLight>
          </O3D>

          <O3D :px="25" :pz="25" :py="10">
            <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOn" :intensity="0.09"></HemisphereLight>
          </O3D>

          <O3D :px="-25" :pz="25" :py="10">
            <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOn" :intensity="0.09"></HemisphereLight>
          </O3D>

          <O3D :px="25" :pz="-25" :py="10">
            <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOn" :intensity="0.09"></HemisphereLight>
          </O3D>

          <O3D :px="-25" :pz="-25" :py="10">
            <HemisphereLight :color="0xffffff" :floorColor="0xbababa" :helper="isDev && isOn" :intensity="0.09"></HemisphereLight>
          </O3D>

          <O3D :px="0" :pz="0" :py="0">
            <AmbinetLight :color="0xffffff" :helper="isDev && isOn" :intensity="0.2"></AmbinetLight>
          </O3D>
        </O3D>

        <!-- <O3D :px="0" :pz="10">
          <GameNPC :char="'mann-mid-poly'" :dance="'Macarena Dance'"></GameNPC>
        </O3D>

        <O3D :px="10" :pz="5">
          <GameNPC :char="'mann-mid-poly'" :dance="'Macarena Dance'"></GameNPC>
        </O3D>

        <O3D :px="-10" :pz="5">
          <GameNPC :char="'mann-mid-poly'" :dance="'Macarena Dance'"></GameNPC>
        </O3D>

        <O3D :px="20" :pz="0">
          <GameNPC :char="'mann-mid-poly'" :dance="'Macarena Dance'"></GameNPC>
        </O3D>

        <O3D :px="-20" :pz="-0">
          <GameNPC :char="'mann-mid-poly'" :dance="'Macarena Dance'"></GameNPC>
        </O3D> -->

        <!-- <O3D :px="30" :pz="-5">
          <GameNPC :char="'mann-mid-poly'" :dance="'Macarena Dance'"></GameNPC>
        </O3D>

        <O3D :px="-30" :pz="-5">
          <GameNPC :char="'mann-mid-poly'" :dance="'Macarena Dance'"></GameNPC>
        </O3D> -->

        <!--
        <O3D v-for="i in 16" :key="i" :px="-30 + -10 * i" :pz="-5">
          <GameNPC :char="'meshman'" :dance="'Macarena Dance'"></GameNPC>
        </O3D> -->

        <O3D :px="0" :pz="10">
          <GameNPC :char="'suzie'" :dance="'Macarena Dance'"></GameNPC>
        </O3D>

        <O3D :px="10" :pz="5">
          <GameNPC :char="'peter'" :dance="'Macarena Dance'"></GameNPC>
        </O3D>

        <O3D :px="-10" :pz="5">
          <GameNPC :char="'alex'" :dance="'Macarena Dance'"></GameNPC>
        </O3D>

        <O3D :px="20" :pz="0">
          <GameNPC :char="'joe'" :dance="'Macarena Dance'"></GameNPC>
        </O3D>

        <O3D :px="30" :pz="-5">
          <GameNPC :char="'frank'" :dance="'Macarena Dance'"></GameNPC>
        </O3D>

        <O3D :px="-30" :pz="-5">
          <GameNPC :char="'janice'" :dance="'Macarena Dance'"></GameNPC>
        </O3D>

        <O3D :px="-20" :pz="-0">
          <GameNPC :char="'ricky'" :dance="'Macarena Dance'"></GameNPC>
        </O3D>

        <!--
        <O3D :px="40" :pz="-10">
          <GameNPC :char="'steve'" :dance="'control standing idle'"></GameNPC>
        </O3D>

        <O3D :px="-40" :pz="-10">
          <GameNPC :char="'david'" :dance="'control standing idle'"></GameNPC>
        </O3D>
        -->

      </O3D>

    </O3D>
  </O3D>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import { Actions } from '../../GLContent/Game/Actions.js'
import { CharNPC } from '../../GLContent/Game/CharNPC.js'
import { ShaderCubeChrome } from '../../Reusable/ShaderCubeChrome'
import { Color } from 'three'

export default {
  mixins: [O3DG2],
  data () {
    return {
      // mainChar: window.innerWidth >= 1280 ? 'swat' : 'suzie',
      chroma: false,
      ready: false,
      layouts: {}
    }
  },
  methods: {
    async setup () {
      let lay = this.layouts
      this.onLoop(() => {
        lay.overall = {
          pz: -50
        }
      })
      this.ready = true
    }
  },
  async mounted () {
    this.chroma = new ShaderCubeChrome({
      res: 32,
      renderer: this.ctx.renderer,
      loop: this.onLoop,
      color: new Color('#ffffff')
    })

    await Promise.all([
      CharNPC.preloadByName({ name: 'mann-mid-poly' }),
      // CharNPC.preloadByName({ name: 'suzie' }),
      // CharNPC.preloadByName({ name: 'peter' }),
      // CharNPC.preloadByName({ name: 'alex' }),
      // // CharNPC.preloadByName({ name: 'swat' }),
      // CharNPC.preloadByName({ name: 'joe' }),
      // CharNPC.preloadByName({ name: 'frank' }),
      // CharNPC.preloadByName({ name: 'janice' }),
      // CharNPC.preloadByName({ name: 'ricky' }),

      Actions.preloadByName({ name: 'Macarena Dance' })
    ])
    this.setup()
  }
}
</script>

<style>

</style>